import { useMemo } from 'react';
import { DateTime } from 'luxon';

export interface DateTimeFormatProps {
  value: string | Date | number | undefined;
  format?: string;
  className?: string;
  children?: React.ReactNode;
  [key: string]: any; // eslint-disable-line @typescript-eslint/no-explicit-any
}

export function DateTimeFormat(
  {
    value,
    format = 'dd-MM-yyyy',
    className
  }:DateTimeFormatProps
) {
  const valueCalculated = useMemo(() => {
    if(!value) {
      return '';
    }
    if (typeof value === 'string' || typeof value === 'object' || typeof value === 'number') {
      return DateTime.fromJSDate(new Date(value)).toFormat(format);
    }
    return DateTime.fromJSDate(value).toFormat(format);
  }, [format, value]);
  return (
    <span className={className}>
      {valueCalculated}
    </span>
  );
}

export default DateTimeFormat;
